export default __webpack_public_path__ + "static/media/sidebar-13.a0830733.png";